<template>
  <div class="container" v-show="windowWidth >= 600">
    <img src="../../../public/logo.png" width="300" style="transform: scale(0.7);" />
    <div class="buttons">
      <a href="https://ademass.com" target="_blank" style="margin-right: 20px;">Sobre Ademass</a>
      <div class="separator"></div>
      <a href="https://campus-ademass.com" style="margin-right: 20px;" target="_blank">Campus</a>
      <div class="separator"></div>
      <a href="https://ademass-profile-request.netlify.app/" style="margin-right: 20px;" target="_blank">Encuentra Talento</a>
      <div class="separator"></div>
      <a href="mailto:negocio@ademass.com" style="margin-right: 20px;" target="_blank">Escríbenos</a>
    </div>
  </div>
  <div class="container-fluid" v-show="windowWidth < 600">
    <div class="mobile-header">
      <v-icon name="gi-hamburger-menu" class="icons" @click="toggleDropdown"></v-icon>
      <img src="../../../public/logo.png" width="300" style="transform: scale(0.7);" />
    </div>
    <div v-show="showDropdown" class="dropdown-content">
      <a href="https://ademass.com" target="_blank">Sobre Ademass</a>
      <a href="https://campus-ademass.com" target="_blank">Campus</a>
      <a href="https://ademass-profile-request.netlify.app/" target="_blank">Encuentra Talento</a>
      <a href="mailto:negocio@ademass.com" target="_blank">Escríbenos</a>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue';
import useWindowWidth from '@/composables/useWindowWidth';

const { windowWidth } = useWindowWidth();
const showDropdown = ref(false);

const toggleDropdown = () => {
  showDropdown.value = !showDropdown.value;
};
</script>

<style scoped>
.dropdown-content {
  display: flex;
  flex-direction: column;
}

.dropdown-content:focus {
  cursor: pointer;
  background-color: #28a3bf;
  color: white;
}

.container {
  z-index: 1000;
  display: flex;
  justify-content: space-between;
  position: fixed;
  top: 0;
  width: 100%;
  padding: 10px;
  padding-bottom: 20px;
  background-color: white;
  box-shadow: 0px 2px 2px -2px #28a3bf;
}

a {
  text-decoration: none;
  color: black;
  font-size: 19px;
  font-family: Darker Grotesque;
  font-weight: 600;
}

.separator {
  width: 10px;
}

.buttons {
  display: flex;
  align-items: center;
  padding-right: 20px;
}

.container-fluid {
  background-color: white;
  width: 100%;
  align-items: flex-start;
  flex-direction: column;
  justify-content: flex-start;
  margin-top: 0;
}

.mobile-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
}

@media screen and (max-width: 900px) {
  .container {
    flex-direction: column;
    box-shadow: 0px -2px 2px -2px #28a3bf; /* Ajustando la sombra para pantallas móviles */
    align-items: center;
    margin-bottom: 0;
    padding-bottom: 0; /* Alineando los elementos al centro */
  }
  a{
    border-bottom: 1px solid #ccc;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .buttons {
    width: 100%;
    justify-content: center;
  }

  img {
    margin-left: 0; /* Ajustando el margen izquierdo a 0 */
    margin-bottom: 10px; /* Añadiendo un margen inferior para separar la imagen de los enlaces */
  }

  .container-fluid {
    margin-bottom: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
}
</style>
